import * as React from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import eventsTracking from '../../utils/eventsTracking';

interface PageTrackerProps {}

const PageTracker: React.FC<PageTrackerProps> = () => {
  const { hash, pathname, search } = useLocation();
  const path = pathname + search + hash;
  React.useEffect(() => {
    eventsTracking.page.view();
  }, [ path ]);

  const { referrerId } = qs.parse(search) as { referrerId?: string };
  React.useEffect(() => {
    if (referrerId) eventsTracking.referrerId.set(referrerId);
  }, [ referrerId ]);
  return null;
};

export default PageTracker;
